/* eslint-disable */
import { Injectable } from '@angular/core';
import { FlowManagerService } from './flowmanager.service';
import { RouteParamsHandler } from './routeParamsHandler.service';
import moment from 'moment';

@Injectable()
export class LoggerService {

  constructor(flowManager: FlowManagerService, routeParamsHandler: RouteParamsHandler) {
    this.flowManager = flowManager;
    this.stepCounter = 0;
    this.logQueue = [];
    this.routeParamsHandler = routeParamsHandler;
  }

  pushToLoggerQueue(logObject) {
    if (typeof logObject == 'object') {
      this.stepCounter++;
      logObject.stepCounter = this.stepCounter;
    }
    this.logQueue.push(logObject);
  }

  getLoggerQueue() {
    const logQueueBuf = this.logQueue;
    this.logQueue = [];
    return logQueueBuf;
  }

  _buildLogPayload(route) {
    let url = route.url;
    if (typeof url === 'string') {
      url = url.replace(/^\//, '').replace(/\?.*$/, '');
    }
    if (route.url[0] === undefined || url == '') {
      url = 'get-started';
    }
    const urlPath = url[0].path || url;

    const experiments = _.map(this.flowManager.experiments, (v, k) =>
      {
        return {
          experimentId: k.replace(/^experiment-/, ''),
          experimentVariation: v
        };
      });
    const accountType = this.flowManager.getAccountType().replace(/^select\-/, '');
    const appType = this.flowManager.getAppType();
    const isAuthed = this.flowManager.isAuthed;

    const logPayload = {
      accountType,
      appType,
      cp: this.routeParamsHandler.getCookie('CP'),
      experiments,
      isAuthed,
      urlArrivingFrom: window.location.href,
      stepId: urlPath,
      startingTimestamp: moment().toISOString()
    };

    return logPayload;
  }

  logPageSubmit(route, errors) {
    const logPayload = this._buildLogPayload(route);

    logPayload.userErrors = errors;
    logPayload.eventType = 'submit';

    this.pushToLoggerQueue(logPayload);
  }

  logPageLoad(route) {
    const logPayload = this._buildLogPayload(route);

    logPayload.eventType = 'load';

    this.pushToLoggerQueue(logPayload);
  }

  logReduxState(state) {
    // this.pushToLoggerQueue(state);
  }
}
